<template>
	<div>
		<v-list-item link :disabled="!detail.enabled" :to="detail.to">
			<v-list-item-content>
				<v-list-item-title class="pl-2">{{ detail.title }}</v-list-item-title>
			</v-list-item-content>
		</v-list-item>
		<v-list-item link :disabled="!detail.enabled" :to="detail.to" :key="detail.title" v-for="detail in pinned_job_worklists">
			<v-list-item-content>
				<v-list-item-title class="pl-2 pin">
					<Pin color="rgba(25, 42, 62, 0.5)" width="16" height="16" class="mr-2"/>
					<div>{{ detail.title === 'All live jobs'? 'All Live and Proposed jobs': detail.title }}</div>
				</v-list-item-title>
			</v-list-item-content>
		</v-list-item>
	</div>
</template>

<script>
import Pin from '@/components/icons/pin';

export default {
	name: 'JobMenuLine',
	props: {
		detail: {
			type: Object,
			default: null
		},
		color: {
			type: String,
			default: "black"
		}
	},
	components: {
		Pin
	},
	computed: {
		pinned_job_worklists() {
			return this.$store.state.pinned_job_worklists;
		}
	},
}	
</script>
<style lang="scss" scoped>
.pin {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-self: center;
}
</style>